import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';

const Retry = ({ message, onClick }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '200px',
        padding: 3,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: 2,
        }}
      >
        {message}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={onClick}
        sx={{
          textTransform: 'none',
          fontWeight: 'bold',
        }}
      >
        {t('retry.tryAgain')}
      </Button>
    </Box>
  );
};

export default Retry;